import { useState, useEffect } from 'react';
import moment from 'moment';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { SlotsCellView } from './SlotsCellView';
import { transformDoctorSlots, getTimeFromMinutes } from '../Helper/utils'
import { formatTime } from "../AddDoctor/timeRanges"
import { dayNames, DURATION_ARRAY } from "../constant"


function EnhancedTableHead() {
  const tableHeaderList = [
    {
      id: 'name',
      disablePadding: false,
      label: 'DURATION 1',
    },
    {
      id: 'name',
      disablePadding: false,
      label: 'DURATION 2',
    },
    {
      id: 'name',
      disablePadding: false,
      label: 'DURATION 3',
    },
  ];
  return (
    <TableHead>
      <TableRow className='flex flex-row'>
        <TableCell
          key={'Day'}
          align={'left'}
          padding={'normal'}
          className={'bg-gray-100 flex-1  px-6 py-3 '}
          sx={{ width: '4.25rem', minHeight: '1.25rem', 'color': '#596C86', 'fontSize': '12px', 'font-weight': 500, borderRight: '1px solid #ddd', padding: '24 14' }}
        >
          Day
        </TableCell>

        {tableHeaderList.map((headCell) => (
          <>
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={'normal'}
              className={'bg-gray-100  flex-5 '}
              sx={{ width: '23.2rem', minHeight: '1.25rem', 'color': '#596C86', 'fontSize': '12px', 'font-weight': 500, borderRight: '1px solid #ddd', }}
            >
              <div className="flex justify-center align-center">
                {headCell.label}
              </div>
            </TableCell>
          </>

        ))}
      </TableRow>
    </TableHead>
  );
}



export const SlotsTable = ({ doctorSlots, setDoctorSlots, makeFormDirty, parentId }) => {

  const [slots, setSlots] = useState({})

  useEffect(() => {
    const formatedDoctorSlots = transformDoctorSlots(doctorSlots || []);
    setSlots(formatedDoctorSlots.DoctorSlots);
  }, [doctorSlots])

  const handleDelete = (data, durationKey, day) => {
    const deleteValue = data[durationKey];
    const time = moment(deleteValue.startTime, "H:m");
    const totalMinutes = time.hours() * 60 + time.minutes();

    const newDoctorSlots = doctorSlots.filter((item) => {
      return !(item.startTime === totalMinutes && item.dayOfWeek === parseInt(day));
    });
    setDoctorSlots(newDoctorSlots);
    makeFormDirty();
  };

  return (
    <>
      <Box sx={{ width: '100%' }} className=''>
        <Paper sx={{ width: '100%', mb: 2, }}>
          <TableContainer>
            <Table
              aria-labelledby="tableTitle"
              size={'medium'}
              sx={{ borderRadius: '1.5rem' }}

            >
              <EnhancedTableHead />

              {slots && Object.entries(slots).map(([day, data], index) => (
                <TableRow
                  hover
                  tabIndex={-1}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    padding="normal"
                    className={"flex gap-2 justify-center "}
                    sx={{
                      borderRight: '1px solid #ddd',
                      color: "#596C86",
                    }}
                  >
                    <div className="flex justify-start align-center text-[#596C86]">
                      {dayNames[day]}
                    </div>
                  </TableCell>
                  {(
                    <>

                      {DURATION_ARRAY.map((durationKey, i) =>
                      (
                        data[durationKey] ? (
                          <TableCell sx={{ borderRight: '1px solid #ddd' }}>

                            <SlotsCellView
                              day={day}
                              data={data}
                              durationKey={durationKey}
                              handleDelete={handleDelete}
                              doctorSlots={doctorSlots}
                              setDoctorSlots={setDoctorSlots}
                              makeFormDirty={makeFormDirty}
                              parentId={parentId}
                              index={i} />

                          </TableCell>
                        ) : <TableCell sx={{ borderRight: '1px solid #ddd' }} ></TableCell>
                      ))}
                    </>
                  )}

                </TableRow>
              ))}
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>

  );
}